import { getRequest } from '@/core';
import { orderTypes } from '@/requests';

export default async function getOrderTypes() {
	let url = orderTypes.getPath();
	return getRequest(url);
}